import { Attraction } from './Describes/Attraction.js';
import { ListDefault } from './Describes/ListDefault.js';

export const Describes = (props) => {
    const { entity, datas } = props;
    if (datas && datas.length > 0) {
        switch (entity) {
            case 'describe_attraction': return (<Attraction entity={entity} datas={datas} />);
            case 'describe_category':
            case 'describe_character':
            case 'describe_experiment':
            case 'describe_family':
            case 'describe_origin':
            case 'describe_page':
            case 'describe_park':
            case 'describe_univers': return (<ListDefault entity={entity} datas={datas} />);
            default: return (<></>);
        }
    } else {
        return (<></>);
    }
}